@if (filteringSupport()) {
  <comp-paged-table-filters
    [filters]="tableFilters()"
    (filtersChanged)="filtersChanged($event)"
    (columnsChanged)="handleColumnsChanged($event)"
  ></comp-paged-table-filters>
}

<div class="table-scroll" #tableScroll [class.has_horizontal_scroll]="hasHorizontalScroll()">
  <table #tableElement mat-table class="ul-table" [dataSource]="dataSource()">
    <ng-content></ng-content>

    <ng-container matColumnDef="menu" stickyEnd>
      <th mat-header-cell *matHeaderCellDef>
        @let menuActions = getActions('menu');

        <button
          comp-button="secondary"
          size="medium"
          [iconOnly]="true"
          [matMenuTriggerFor]="menu"
          (click)="$event.stopPropagation()"
        >
          <i comp-icon size="medium">more_vert</i>
        </button>
        <mat-menu #menu="matMenu">
          @for (action of menuActions; track action.id) {
            @if (action.id === 'delete' && isSupported('menu', 'delete')) {
              <button mat-menu-item (click)="enterDeleteMode()">
                <i comp-icon matMenuItemIcon>delete</i>
                {{ 'general.delete' | translate }}
              </button>
            } @else {
              <button mat-menu-item (click)="executeAction(action)">
                <i comp-icon matMenuItemIcon>{{ action.icon }}</i>
                {{ action.labelMessageKey | translate }}
              </button>
            }
          }
        </mat-menu>
      </th>
      <td mat-cell *matCellDef="let row">
        @let menuActions = getActions('contextMenu', row);
        @if (menuActions.length > 0) {
          <button
            comp-button="secondary"
            size="medium"
            [iconOnly]="true"
            [matMenuTriggerFor]="menu"
            (click)="$event.stopPropagation()"
          >
            <i comp-icon size="medium">more_vert</i>
          </button>
          <mat-menu #menu="matMenu">
            @for (action of menuActions; track action.id) {
              <button mat-menu-item (click)="executeAction(action, row); $event.stopPropagation()">
                <i comp-icon matMenuItemIcon>{{ action.icon }}</i>
                {{ action.labelMessageKey | translate }}
              </button>
            }
          </mat-menu>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="select" stickyEnd>
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          (change)="$event ? toggleAllRows() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
        >
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)"
        >
        </mat-checkbox>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay()"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: columnsToDisplay()"
      [ngClass]="getRowClass(row)"
      (click)="handleRowClicked(row, $event)"
    ></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="columnsToDisplay().length">No data</td>
    </tr>
  </table>
</div>
@if (isDeleteMode()) {
  <div class="delete-mode-actions">
    <button comp-button="secondary" type="button" (click)="handleCancelDelete()">
      <span translate="general.cancel"></span>
    </button>
    <button
      type="button"
      comp-button
      [disabled]="selection.selected.length === 0"
      (click)="handleDeleteMultiple()"
    >
      <span translate="general.delete"></span>
    </button>
  </div>
}

@if (!hidePaginator()) {
  <mat-paginator (page)="handlePageEvent($event)" [disabled]="isDeleteMode()"></mat-paginator>
}
